module.exports = __webpack_public_path__ + "static/media/8.Star PNG 2.c09e8b56.gif";